import { ComponentProps, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, Tabs } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import WorkspaceEditModalDanger from './WorkspaceEditModalDanger';
import WorkspaceEditModalPlan from './WorkspaceEditModalPlan';
import WorkspaceEditModalSupport from './WorkspaceEditModalSupport';

export default function WorkspaceEditModal(props: {
	workspace: graphql.Workspace & ComponentProps<typeof WorkspaceEditModalPlan>['workspace'];
	onDismiss: () => void;
	initialTab: 'plan' | 'support' | 'danger';
}) {
	const { t } = useTranslation();

	const [tab, setTab] = useState(props.initialTab);

	return (
		<Modal width={600} height={500}>
			<Modal.Header title={t('settings.workspaces.edit.title')} tabs onClose={props.onDismiss} />
			<Tabs>
				<Tabs.Item
					title={t('settings.workspaces.edit.plan.title')}
					selected={tab === 'plan'}
					onClick={() => setTab('plan')}
				/>
				<Tabs.Item
					title={t('settings.workspaces.edit.support.title')}
					selected={tab === 'support'}
					onClick={() => setTab('support')}
				/>
				<Tabs.Item
					title={t('settings.workspaces.edit.dangerZone.title')}
					selected={tab === 'danger'}
					onClick={() => setTab('danger')}
				/>
			</Tabs>
			{tab === 'plan' && <WorkspaceEditModalPlan workspace={props.workspace} />}
			{tab === 'support' && (
				<WorkspaceEditModalSupport workspace={props.workspace} onDismiss={props.onDismiss} />
			)}
			{tab === 'danger' && (
				<WorkspaceEditModalDanger workspace={props.workspace} onDismiss={props.onDismiss} />
			)}
		</Modal>
	);
}
